import { TextField } from "@mui/material";
import React from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import { Validardocumento } from "./ValidarDocumento";
import request from "../../../Helpers/API";

export const ModalDocumentoScresn = ({
  idclientedocumento,
  orden,
  iddocumento,
  documento,
  idcliente,
  setDocumentos,
}) => {
  const closedModal = () => {
    var modal = document.getElementById("modal-documentos");
    modal.style.display = "none";
    setState({
      documento: "",
      vencimiento: "",
      comentarios: "",
      estatus: true,
    });
  };
  const [state, setState] = useState({
    documento: "",
    vencimiento: "",
    comentarios: "",
    estatus: true,
    extension: "",
  });
  const onGuardar = () => {
    var valido = Validardocumento(state);
    if (valido === false) {
      return;
    }
    valido.idclientedocumento = Number(idclientedocumento);
    valido.orden = Number(orden);
    valido.iddocumento = Number(iddocumento);
    valido.idcliente = Number(idcliente);
    request
      .post("ClienteDocumentacion", valido)
      .then(async (result) => {
        await Swal.fire("Clientes", "Documento cargado con exito", "success");
        setDocumentos(result.listado);
        closedModal();
      })
      .catch((error) => Swal.fire("clientes", JSON.stringify(error), "error"));
  };
  const GetFile = ({ target }) => {
    if (
      target.files === undefined ||
      target.files === null ||
      target.files.length == 0
    )
      return;

    const file = target.files[0].name.split(".");
    if (file.length > 2) {
      Swal.fire("Clientes", "Archivo invalido", "error");
      return;
    }

    if (file[1] != "jpg" && file[1] != "jepg" && file[1] != "pdf") {
      Swal.fire("Clientes", "Archivo con formato no valido", "error");
      target.value = "";
      return;
    }

    // const filelength = Number(target.files[0].size) / 1000;
    // if (filelength > 10000) {
    //   Swal.fire(
    //     "Clientes",
    //     "Archivo demasiado grande favor de comprimir",
    //     "error"
    //   );
    //   target.value = "";
    //   return;
    // }
    var fReader = new FileReader();
    fReader.readAsDataURL(target.files[0]);
    fReader.onloadend = function (event) {
      setState({
        ...state,
        documento: event.target.result,
        extension: file[1],
      });
    };
  };
  return (
    <div id="modal-documentos" class="modal">
      <div class="modal-content-documentos">
        <div class="modal-header-documentos">
          <span class="close" onClick={closedModal}>
            &times;
          </span>
          <div className="encabezado">
            <div className="titulo">{documento}</div>
            <div className="border-green"></div>
          </div>
        </div>
        <div class="modal-body-documentos">
          <div className="div-documentos-text">
            <TextField
              id="clientes-documento"
              type="file"
              className="w-80"
              onChange={GetFile}
              sx={{ mb: 2, width: 100 }}
            />
            <TextField
              id="date"
              label="Vencimiento"
              type="date"
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
              onChange={({ target }) =>
                setState({ ...state, vencimiento: target.value })
              }
              value={state.vencimiento}
            />
          </div>
          <TextField
            id="date"
            fullWidth
            label="Comentarios"
            type="Text"
            multiline
            maxRows={3}
            rows={3}
            InputLabelProps={{ shrink: true }}
            onChange={({ target }) =>
              setState({ ...state, comentarios: target.value })
            }
            value={state.comentarios}
          />
        </div>
        <div className="footer-guardar-domicilio">
          <div className="button-guardar" onClick={onGuardar}>
            Guardar
          </div>
        </div>
      </div>
    </div>
  );
};
